import React from "react";

interface IProps {
  className?: string;
  children: React.ReactNode;
}

export default function H2(props: IProps) {
  return (
    <h1 className="text-bold text-xl md:text-3xl py-3">{props.children}</h1>
  );
}
